import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import cn from 'classnames';

import BrIcons from '@components/BrIcons';
import BrInputBox from '@components/BrInputBox';
import BrText from '@components/BrText';
import './brEditableLabel.scss';

const isValid = (val) => val !== null && val !== undefined;

export default class BrEditableLabel extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isInputStyle: PropTypes.bool,
    onSetLabel: PropTypes.func.isRequired,
  };

  static defaultProps = {
    suggestions: [],
    placeholder: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      tmpValue: props.value,
      currentValue: props.value,
    }; // may use initial props
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    // setState -> no rerender
    // this step is will not be invoked by this.setState
    this.setState({ currentValue: nextProps.value, tmpValue: nextProps.value });
  }

  handleConfirmChange = () => {
    const { onSetLabel } = this.props;
    const { tmpValue } = this.state;
    if (onSetLabel) {
      onSetLabel(isValid(tmpValue) ? tmpValue : '');
    }
    this.handleSetToLabel();
  };

  handleSetToLabel = () => {
    this.setState({ tmpValue: this.state.currentValue, isEditing: false });
  };

  handleBlur = (e) => {
    if (!(e.relatedTarget && e.relatedTarget.classList.contains('label-editor'))) {
      this.handleConfirmChange();
    }
  };

  handleReset = () => {
    const { placeholder, onSetLabel } = this.props;
    if (onSetLabel) {
      onSetLabel(placeholder);
    }
    this.setState({
      tmpValue: placeholder,
      currentValue: placeholder,
    });
  };

  render() {
    const { className, placeholder, isInputStyle } = this.props;
    const { isEditing, tmpValue, currentValue } = this.state;
    const classname = cn('br-editable-label', className, { 'input-style': isInputStyle });

    return (
      <div className={classname} data-id="br-editable-label">
        {isEditing ? (
          <div className="label-editor" tabIndex="0" onBlur={this.handleBlur}>
            <BrInputBox
              className="label-editor-input"
              placeholder={placeholder}
              autoFocus
              value={isValid(tmpValue) ? tmpValue : ''}
              onInput={(val) => this.setState({ tmpValue: val })}
              onEnter={this.handleConfirmChange}
            />
            <span onClick={this.handleConfirmChange}>
              <BrIcons.Check isSubComp />
            </span>
            <span onClick={this.handleSetToLabel}>
              <BrIcons.Cross isSubComp />
            </span>
          </div>
        ) : (
          <div className="label-text">
            <span onClick={() => this.setState({ isEditing: true })}>
              <BrText>{isValid(currentValue) ? currentValue : placeholder}</BrText>
              {!isInputStyle && (
                <span className="edit-btn">
                  <BrIcons.Edit isSubComp />
                </span>
              )}
            </span>
            {isValid(tmpValue) && tmpValue !== placeholder && (
              <>
                <span className="pipe-symbol">&nbsp;|&nbsp;</span>
                <span onClick={this.handleReset}>
                  <BrIcons.Undo isSubComp />
                </span>
              </>
            )}
          </div>
        )}
      </div>
    );
  }
}
